"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferMessageDetailResponseSchema = exports.OfferMessageDetailResultSchema = exports.OfferMessagesListResponseSchema = exports.OfferMessagesListResultSchema = exports.OfferMessageItemSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const schemas_1 = require("../../../../../schemas");
const offers_1 = require("../../../../../schemas/offers");
exports.OfferMessageItemSchema = zod_1.default.discriminatedUnion('type', [offers_1.OfferLetterSchema, offers_1.OfferReminderSchema]);
exports.OfferMessagesListResultSchema = zod_1.default.object({
    messages: exports.OfferMessageItemSchema.array(),
});
exports.OfferMessagesListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OfferMessagesListResultSchema);
exports.OfferMessageDetailResultSchema = zod_1.default.object({
    message: exports.OfferMessageItemSchema,
});
exports.OfferMessageDetailResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OfferMessageDetailResultSchema);
